module.exports = __webpack_public_path__ + "e8cb9cbc702435e4b44254c07f225f80.svg";